import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import TopNav from '../components/TopNav';
import SocialFooter from '../components/SocialFooter';
import { Play, SignIn } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";
const WOMAN_IMAGE = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/k9waamf7_755A0386-E611-42B8-9C89-BB24AB55A3E4.jpeg";
const MAN_IMAGE = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/ko6t1f2b_38AEA7ED-1183-4C99-A9A1-E0CD3E80DD41.jpeg";
const BOOK_COVER = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/coesf93v_ChatGPT%20Image%20Mar%2026%2C%202026%2C%2002_05_30%20AM.png";

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col relative overflow-hidden" data-testid="welcome-screen">
      {/* Watermark - 25% bigger, spread out */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage: `url(${LOGO_URL})`,
          backgroundPosition: 'center 30%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '75%',
        }}
      />

      <TopNav showHome={false} />

      <div className="flex-1 flex items-center justify-center px-6 py-4 relative z-10">
        <div className="max-w-5xl w-full flex flex-col lg:flex-row items-center gap-8 lg:gap-12">

          {/* Left: Content */}
          <div className="flex-1 text-center lg:text-left">
            <img src={LOGO_URL} alt="Track365 Cardio" className="w-40 h-auto mx-auto lg:mx-0 mb-5" data-testid="welcome-logo" />

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-foreground mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Track Your Cardio.<br />
              <span className="text-[#D4AF37]">Transform Your Body.</span>
            </h1>

            <p className="text-muted-foreground mb-1 text-lg">Your 365-day cardio journey starts here.</p>
            <p className="text-muted-foreground mb-6 text-sm">Track every session. Build every win.</p>

            <div className="space-y-3 max-w-sm mx-auto lg:mx-0">
              <Button onClick={() => navigate('/pricing')} className="w-full bg-[#D4AF37] text-black font-bold uppercase tracking-widest rounded-full py-6 hover:bg-[#F3E5AB] transition-all text-base" data-testid="start-trial-btn">
                <Play weight="fill" className="w-5 h-5 mr-2" />
                Start Free Trial
              </Button>
              <Button onClick={() => navigate('/pricing')} variant="outline" className="w-full border-[#D4AF37]/30 text-foreground rounded-full py-5 hover:border-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all" data-testid="view-plans-btn">
                View Plans
              </Button>
              <Button onClick={() => navigate('/login')} variant="ghost" className="w-full text-muted-foreground rounded-full py-4 hover:text-foreground transition-all text-sm" data-testid="login-btn">
                <SignIn weight="regular" className="w-4 h-4 mr-2" />
                Already a member? Log In
              </Button>
            </div>
            <p className="mt-6 text-xs tracking-[0.2em] uppercase text-[#D4AF37]/60">TRACK IT. BUILD IT. BECOME IT.</p>
          </div>

          {/* Right: 3 vertical images - Woman | Book (half size, middle) | Man - all same width */}
          <div className="flex-shrink-0 flex items-start gap-2 w-full max-w-[320px]">
            {/* Woman - full body */}
            <div className="flex-1 rounded-xl overflow-hidden shadow-md border border-[#D4AF37]/10">
              <img src={WOMAN_IMAGE} alt="Woman on treadmill" className="w-full h-auto object-contain" />
            </div>
            {/* Book - in the middle, half size */}
            <div className="flex-1 flex items-center">
              <a href="/buy-book" className="block rounded-xl overflow-hidden shadow-md border border-emerald-500/20 hover:border-emerald-400/40 transition-all">
                <img src={BOOK_COVER} alt="Track365 Cardio Logbook" className="w-full h-auto object-contain" data-testid="book-link-welcome" />
              </a>
            </div>
            {/* Man - full body */}
            <div className="flex-1 rounded-xl overflow-hidden shadow-md border border-[#D4AF37]/10">
              <img src={MAN_IMAGE} alt="Man on stationary bike" className="w-full h-auto object-contain" />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto w-full px-6">
        <SocialFooter />
      </div>
    </div>
  );
};

export default Welcome;
